// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import * as evtApi from "../api/events";
// import * as commApi from "../api/community";
// import bgImg from "../assets/1.png";

// export default function EventForm() {
//   const navigate = useNavigate();

//   const [communities, setCommunities] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [subCategories, setSubCategories] = useState([]);

//   const [previewLogo,  setPreviewLogo]  = useState("");
//   const [previewImage, setPreviewImage] = useState("");

//   const [form, setForm] = useState({
//     community_id: "",
//     name: "",
//     description: "",
//     contact: "",
//     email: "",
//     address: "",
//     in_charge: "",
//     logo: "",
//     image: "",
//     category: "",
//     sub_category: "",
//     social_links: { instagram:"", facebook:"", x:"", youtube:"", Website:"" }
//   });

//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     (async () => {
//       try {
//         const list = await commApi.listCommunities();
//         const arr = Array.isArray(list) ? list : (list?.rows ?? []);
//         setCommunities(arr);
//       } catch { setCommunities([]); }
//       try {
//         const cats = await evtApi.listCategories();
//         setCategories(Array.isArray(cats) ? cats : []);
//       } catch { setCategories([]); }
//     })();
//   }, []);

//   useEffect(() => {
//     setForm(f => ({ ...f, sub_category: "" }));
//     if (!form.category) { setSubCategories([]); return; }
//     (async () => {
//       try {
//         const subs = await evtApi.listSubCategories({ categoryName: form.category });
//         setSubCategories(Array.isArray(subs) ? subs : []);
//       } catch { setSubCategories([]); }
//     })();
//   }, [form.category]);

//   const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
//   const handleSocialChange = (k, v) => setForm(prev => ({ ...prev, social_links: { ...prev.social_links, [k]: v }}));

//   const handleFileChange = e => {
//     const { name, files } = e.target;
//     const file = files?.[0];
//     if (!file) return;
//     const url = URL.createObjectURL(file);
//     if (name === "logo") setPreviewLogo(url);
//     if (name === "image") setPreviewImage(url);
//     setForm(prev => ({ ...prev, [name]: file }));
//   };

//   const handleSubmit = async e => {
//     e.preventDefault();
//     setLoading(true); setError("");

//     try {
//       const needMultipart = form.logo instanceof File || form.image instanceof File;
//       let payload;
//       if (needMultipart) {
//         payload = new FormData();
//         Object.entries(form).forEach(([k, v]) => {
//           if (k === "social_links") payload.append(k, JSON.stringify(v));
//           else if (v instanceof File) payload.append(k, v, v.name);
//           else payload.append(k, v ?? "");
//         });
//       } else {
//         payload = { ...form, social_links: JSON.stringify(form.social_links) };
//       }
//       await evtApi.createEvent(payload);
//       navigate("/events");
//     } catch (err) {
//       setError(err?.response?.data?.error || "Failed to create event");
//     } finally { setLoading(false); }
//   };

//   return (
//     <section className="cf-section">
//       <style>{`
//         .cf-section { min-height:100vh; display:flex; align-items:center; justify-content:center;
//           background-image:url(${bgImg}), linear-gradient(135deg, rgba(210,168,87,.7), rgba(139,186,161,.7), rgba(5,102,117,.7));
//           background-size:cover; background-position:center; padding:1rem; }
//         .cf-card { width:100%; max-width:40rem; background:#ffffffc7; border-radius:1rem; box-shadow:0 10px 25px rgba(0,0,0,.1); padding:1.25rem; display:grid; gap:.8rem; grid-template-columns: repeat(2, 1fr); }
//         .cf-title { grid-column:span 2; font-size:1.6rem; font-weight:900; color:#7A133D; text-align:center; }
//         .cf-field { display:flex; flex-direction:column; gap:.25rem; font-size:.9rem; }
//         .cf-full { grid-column:span 2; }
//         .cf-btn { background:#C62039; color:#fff; border:none; border-radius:.5rem; padding:.6rem; font-weight:700; cursor:pointer; }
//         .cf-error { color:#b91c1c; text-align:center; font-weight:600; }
//       `}</style>

//       <form className="cf-card" onSubmit={handleSubmit}>
//         <h2 className="cf-title">Add Event</h2>

//         <label className="cf-field">
//           Category
//           <select name="category" value={form.category} onChange={handleChange}>
//             <option value="">(Optional)</option>
//             {(categories ?? []).map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
//           </select>
//         </label>

//         <label className="cf-field">
//           Sub-category
//           <select name="sub_category" value={form.sub_category} onChange={handleChange} disabled={!form.category}>
//             <option value="">{form.category ? '(Optional)' : 'Choose category first'}</option>
//             {(subCategories ?? []).map(sc => <option key={sc.id} value={sc.name}>{sc.name}</option>)}
//           </select>
//         </label>

//         <label className="cf-field">
//           Community
//           <select name="community_id" value={form.community_id} onChange={handleChange} required>
//             <option value="">Select community</option>
//             {(communities ?? []).map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
//           </select>
//         </label>


//         <label className="cf-field">
//           Name
//           <input name="name" value={form.name} onChange={handleChange} required />
//         </label>

//         <label className="cf-field">
//           Contact
//           <input name="contact" value={form.contact} onChange={handleChange} required />
//         </label>

//         <label className="cf-field">
//           Email
//           <input name="email" value={form.email} onChange={handleChange} required />
//         </label>

//         <label className="cf-field cf-full">
//           Address
//           <input name="address" value={form.address} onChange={handleChange} required />
//         </label>

//         <label className="cf-field">
//           In-charge
//           <input name="in_charge" value={form.in_charge} onChange={handleChange} required />
//         </label>

//         <label className="cf-field cf-full">
//           Description
//           <textarea name="description" rows={3} value={form.description} onChange={handleChange} required />
//         </label>

//         <div className="cf-field cf-full">
//           <label>Social Links</label>
//           {["instagram","facebook","x","youtube","Website"].map(p => (
//             <input key={p} placeholder={`${p.toUpperCase()} URL`} value={form.social_links[p] || ""}
//                    onChange={e => handleSocialChange(p, e.target.value)} />
//           ))}
//         </div>

//         <div className="cf-field cf-full">
//           <label>Logo (upload or paste URL)</label>
//           <input type="text" placeholder="https://…logo.png"
//                  value={typeof form.logo === "string" ? form.logo : ""}
//                  onChange={e => { setPreviewLogo(e.target.value); setForm(prev => ({ ...prev, logo: e.target.value })); }} />
//           <input type="file" name="logo" accept="image/*" onChange={handleFileChange} />
//           {previewLogo && <img src={previewLogo} alt="logo preview" style={{ maxWidth: 120, marginTop: 6 }} />}
//         </div>

//         <div className="cf-field cf-full">
//           <label>Banner (upload or paste URL)</label>
//           <input type="text" placeholder="https://…banner.jpg"
//                  value={typeof form.image === "string" ? form.image : ""}
//                  onChange={e => { setPreviewImage(e.target.value); setForm(prev => ({ ...prev, image: e.target.value })); }} />
//           <input type="file" name="image" accept="image/*" onChange={handleFileChange} />
//           {previewImage && <img src={previewImage} alt="banner preview" style={{ maxWidth: 180, marginTop: 6 }} />}
//         </div>

//         {error && <p className="cf-error cf-full">{error}</p>}
//         <button className="cf-btn cf-full" disabled={loading}>{loading ? "Saving…" : "Save"}</button>
//       </form>
//     </section>
//   );
// }



// src/pages/EventForm.jsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as evtApi from "../api/events";
import * as commApi from "../api/community";
import bgImg from "../assets/1.png";

export default function EventForm() {
  const navigate = useNavigate();

  const [communities, setCommunities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  const [previewLogo,  setPreviewLogo]  = useState("");
  const [previewImage, setPreviewImage] = useState("");

  const [form, setForm] = useState({
    community_id: "",
    name: "",
    description: "",
    contact: "",
    email: "",
    address: "",
    in_charge: "",
    logo: "",
    image: "",
    category: "",
    sub_category: "",
    social_links: { instagram:"", facebook:"", x:"", youtube:"", Website:"" }
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // helper to normalize possible {rows:[]} responses
  const pickRows = (payload) => Array.isArray(payload) ? payload : (payload?.rows ?? []);

  /* ───────── initial loads ───────── */
  useEffect(() => {
    (async () => {
      try {
        const cats = await evtApi.listCategories();
        setCategories(Array.isArray(cats) ? cats : []);
      } catch {
        setCategories([]);
      }

      // initial communities (no filters)
      try {
        const list = await commApi.listCommunities();
        setCommunities(pickRows(list));
      } catch {
        setCommunities([]);
      }
    })();
  }, []);

  /* ───────── when category changes, load sub-categories ───────── */
  useEffect(() => {
    setForm(f => ({ ...f, sub_category: "" })); // reset sub-category
    setSubCategories([]);

    if (!form.category) return;

    (async () => {
      try {
        const subs = await evtApi.listSubCategories({ categoryName: form.category });
        setSubCategories(Array.isArray(subs) ? subs : []);
      } catch {
        setSubCategories([]);
      }
    })();
  }, [form.category]);

  /* ───────── filter communities by category/sub-category ───────── */
  useEffect(() => {
    (async () => {
      const params = {};
      if (form.category)     params.category = form.category;
      if (form.sub_category) params.subCategory = form.sub_category; // backend expects camelCase

      try {
        const list = await commApi.listCommunities(params);
        const arr  = pickRows(list);
        setCommunities(arr);

        // if current selection no longer valid, clear it
        if (form.community_id && !arr.find(c => c.id === form.community_id)) {
          setForm(f => ({ ...f, community_id: "" }));
        }
      } catch {
        setCommunities([]);
      }
    })();
  }, [form.category, form.sub_category]); // re-run when filters change

  /* ───────── handlers ───────── */
  const handleChange = (e) => {
    const { name, value } = e.target;

    // keep selects in sync
    if (name === "category") {
      setForm(prev => ({ ...prev, category: value, sub_category: "", community_id: "" }));
      return;
    }
    if (name === "sub_category") {
      setForm(prev => ({ ...prev, sub_category: value, community_id: "" }));
      return;
    }

    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSocialChange = (k, v) =>
    setForm(prev => ({ ...prev, social_links: { ...prev.social_links, [k]: v }}));

  const handleFileChange = e => {
    const { name, files } = e.target;
    const file = files?.[0];
    if (!file) return;
    const url = URL.createObjectURL(file);
    if (name === "logo")  setPreviewLogo(url);
    if (name === "image") setPreviewImage(url);
    setForm(prev => ({ ...prev, [name]: file }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true); setError("");

    try {
      const needMultipart = form.logo instanceof File || form.image instanceof File;
      let payload;

      if (needMultipart) {
        payload = new FormData();
        Object.entries(form).forEach(([k, v]) => {
          if (k === "social_links") payload.append(k, JSON.stringify(v));
          else if (v instanceof File) payload.append(k, v, v.name);
          else payload.append(k, v ?? "");
        });
      } else {
        payload = { ...form, social_links: JSON.stringify(form.social_links) };
      }

      await evtApi.createEvent(payload);
      navigate("/events");
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to create event");
    } finally {
      setLoading(false);
    }
  };

  /* ───────── UI ───────── */
  return (
    <section className="cf-section">
      <style>{`
        :root {
          --royal-red: #7A133D;
          --heritage-red: #C62039;
          --royal-gold: #D2A857;
          --royal-cream: #FFF9F2;
          --sage: #8BBAA1;
          --teal: #056675;
        }
        .cf-section {
          min-height:100vh; display:flex; align-items:center; justify-content:center;
          background-image:url(${bgImg}), linear-gradient(135deg, rgba(210,168,87,.7), rgba(139,186,161,.7), rgba(5,102,117,.7));
          background-size:cover; background-position:center; padding:1rem;
          font-family: "Merriweather", "Georgia", serif;
        }
        /* translucent + blur card */
        .cf-card {
          width:100%; max-width:40rem;
          background: rgba(255,255,255,0.78);
          backdrop-filter: blur(6px);
          border-radius:1rem; box-shadow:0 10px 25px rgba(0,0,0,.1);
          padding:1.25rem; display:grid; gap:.8rem; grid-template-columns: repeat(2, 1fr);
        }
        .cf-title { grid-column:span 2; font-size:1.8rem; font-weight:900; color:var(--heritage-red); text-align:center; }
        .cf-field { display:flex; flex-direction:column; gap:.25rem; font-size:.9rem; color:var(--royal-red); }
        .cf-field input, .cf-field textarea, .cf-field select {
          border: 2px solid transparent; border-radius:.5rem; padding:.5rem .75rem; font-size:.9rem;
        }
        .cf-field input:focus, .cf-field textarea:focus, .cf-field select:focus {
          outline:none; border-color: var(--royal-gold); box-shadow:0 0 0 3px rgba(210,168,87,.35);
        }
        .cf-full { grid-column:span 2; }
        .cf-btn { background:var(--heritage-red); color:#fff; border:none; border-radius:.5rem; padding:.6rem; font-weight:700; cursor:pointer; }
        .cf-btn:hover { background: var(--royal-red); }
        .cf-error { color:#b91c1c; text-align:center; font-weight:600; }
      `}</style>

      <form className="cf-card" onSubmit={handleSubmit}>
        <h2 className="cf-title">Add Event</h2>

        <label className="cf-field">
          Category
          <select name="category" value={form.category} onChange={handleChange}>
            <option value="">(Optional)</option>
            {(categories ?? []).map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
          </select>
        </label>

        <label className="cf-field">
          Sub-category
          <select
            name="sub_category"
            value={form.sub_category}
            onChange={handleChange}
            disabled={!form.category}
          >
            <option value="">{form.category ? '(Optional)' : 'Choose category first'}</option>
            {(subCategories ?? []).map(sc => <option key={sc.id} value={sc.name}>{sc.name}</option>)}
          </select>
        </label>

        <label className="cf-field">
          Community
          <select
            name="community_id"
            value={form.community_id}
            onChange={handleChange}
            required
          >
            <option value="">
              {form.sub_category ? 'Select community in this sub-category' : 'Select community'}
            </option>
            {(communities ?? []).map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </label>

        <label className="cf-field">
          Name
          <input name="name" value={form.name} onChange={handleChange} required />
        </label>

        <label className="cf-field">
          Contact
          <input name="contact" value={form.contact} onChange={handleChange} required />
        </label>

        <label className="cf-field">
          Email
          <input name="email" value={form.email} onChange={handleChange} required />
        </label>

        <label className="cf-field cf-full">
          Address
          <input name="address" value={form.address} onChange={handleChange} required />
        </label>

        <label className="cf-field">
          In-charge
          <input name="in_charge" value={form.in_charge} onChange={handleChange} required />
        </label>

        <label className="cf-field cf-full">
          Description
          <textarea name="description" rows={3} value={form.description} onChange={handleChange} required />
        </label>

        <div className="cf-field cf-full">
          <label>Social Links</label>
          {["instagram","facebook","x","youtube","Website"].map(p => (
            <input
              key={p}
              placeholder={`${p.toUpperCase()} URL`}
              value={form.social_links[p] || ""}
              onChange={e => handleSocialChange(p, e.target.value)}
            />
          ))}
        </div>

        <div className="cf-field cf-full">
          <label>Logo (upload or paste URL)</label>
          <input
            type="text"
            placeholder="https://…logo.png"
            value={typeof form.logo === "string" ? form.logo : ""}
            onChange={e => {
              setPreviewLogo(e.target.value);
              setForm(prev => ({ ...prev, logo: e.target.value }));
            }}
          />
          <input type="file" name="logo" accept="image/*" onChange={handleFileChange} />
          {previewLogo && <img src={previewLogo} alt="logo preview" style={{ maxWidth: 120, marginTop: 6 }} />}
        </div>

        <div className="cf-field cf-full">
          <label>Banner (upload or paste URL)</label>
          <input
            type="text"
            placeholder="https://…banner.jpg"
            value={typeof form.image === "string" ? form.image : ""}
            onChange={e => {
              setPreviewImage(e.target.value);
              setForm(prev => ({ ...prev, image: e.target.value }));
            }}
          />
          <input type="file" name="image" accept="image/*" onChange={handleFileChange} />
          {previewImage && <img src={previewImage} alt="banner preview" style={{ maxWidth: 180, marginTop: 6 }} />}
        </div>

        {error && <p className="cf-error cf-full">{error}</p>}
        <button className="cf-btn cf-full" disabled={loading}>
          {loading ? "Saving…" : "Save"}
        </button>
      </form>
    </section>
  );
}
